module.exports = __webpack_public_path__ + "media/img/institutions/default_logo-670b18c399b3a6807e30459e8e220d37.svg";